export default function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-border/50 bg-ink py-16 px-6">
      <div className="max-w-7xl mx-auto grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="serif text-3xl text-bone mb-4">Legacy<span className="text-gold">.</span></div>
          <p className="text-bone/50 text-sm max-w-sm leading-relaxed">Estate planning built on trust. Protecting families, preserving legacies, one plan at a time.</p>
        </div>
        <div className="md:col-span-3 md:col-start-8">
          <div className="overline text-gold mb-4">Services</div>
          <ul className="space-y-2 text-bone/60 text-sm">
            <li>Wills &amp; Testaments</li><li>Living Trusts</li><li>Power of Attorney</li><li>Probate Administration</li>
          </ul>
        </div>
        <div className="md:col-span-2">
          <div className="overline text-gold mb-4">Contact</div>
          <ul className="space-y-2 text-bone/60 text-sm">
            <li>hello@legacylaw.com</li><li>+1 (555) 018-2200</li><li>Mon–Fri, 9–6</li>
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto mt-14 pt-8 border-t border-border/40 flex flex-col sm:flex-row justify-between gap-3 text-bone/30 text-xs">
        <span>© {new Date().getFullYear()} Legacy Law. All rights reserved.</span>
        <span>General information only — not legal advice.</span>
      </div>
    </footer>
  );
}
